"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_1 = tslib_1.__importStar(require("react"));
const react_hanger_1 = require("react-hanger");
const react_moment_1 = tslib_1.__importDefault(require("react-moment"));
const react_router_dom_1 = require("react-router-dom");
const react_use_1 = require("react-use");
const reactstrap_1 = require("reactstrap");
const reusables_1 = require("../../../../comps/reusables");
const CheckIcon_1 = require("../../../../comps/reusables/CheckIcon");
const graphql_1 = require("../../../../graphql");
const ResourceList_1 = require("../ResourceList");
const ResourceListTable_1 = require("../ResourceListTable");
const react_2 = require("@osmosys/react");
const hooks_1 = require("../../../../hooks");
const AddWorkspaceModal = react_router_dom_1.withRouter(({ isOpen, onClose, history }) => {
    const input = react_hanger_1.useInput('');
    const [newWorkspaceId, setWorkspaceId] = react_1.default.useState(null);
    // Redirect when mutation was successful
    react_1.useEffect(() => {
        let t;
        if (!isNaN(newWorkspaceId) && newWorkspaceId !== null) {
            t = setTimeout(() => {
                history.push(`/admin/workspaces/${newWorkspaceId}`);
            }, 2 * 1000);
        }
        return () => {
            clearTimeout(t);
        };
    }, [history, newWorkspaceId]);
    const { save, mutationResult } = hooks_1.useAddWorkspace(input.value, id => {
        setWorkspaceId(id);
    });
    const disabled = !!(newWorkspaceId || mutationResult.loading);
    return (react_1.default.createElement(react_2.OsmosysModal, { osysName: "WorkspacesList", osysSubType: "Create", isOpen: isOpen, centered: true, toggle: () => onClose() },
        react_1.default.createElement(reactstrap_1.ModalHeader, { toggle: () => onClose() }, newWorkspaceId ? 'Redirecting...' : 'Add new workspace'),
        react_1.default.createElement(reactstrap_1.ModalBody, null,
            react_1.default.createElement(reactstrap_1.FormGroup, null,
                react_1.default.createElement(reactstrap_1.Label, null, "Name"),
                react_1.default.createElement(reactstrap_1.Input, Object.assign({ type: "text", placeholder: "Name" }, input.eventBind, { disabled: disabled }))),
            react_1.default.createElement(reusables_1.AjaxButton, { label: newWorkspaceId ? 'Redirecting...' : 'Create workspace', onClick: () => {
                    save();
                }, color: "success", error: mutationResult.error, success: !!mutationResult.data, loading: mutationResult.loading, disabled: disabled }),
            react_1.default.createElement(react_2.OsmosysErrorAlert, { apolloError: mutationResult.error, resource: "Workspace", action: "create" }))));
});
exports.WorkspacesList = () => {
    const [showAddWorkspaceModal, toggleAddWorkspaceModal] = react_use_1.useToggle(false);
    return (react_1.default.createElement(ResourceListTable_1.ResourceListTable, { variables: context => {
            return {
                searchQuery: context.state.searchQuery,
            };
        }, cells: ws => {
            return [
                react_1.default.createElement("span", { className: classnames_1.default('font-weight-bold', !ws.name && 'text-muted'), key: 1 },
                    react_1.default.createElement(react_router_dom_1.Link, { className: "text-reset", to: `/admin/workspaces/${ws.id}` }, ws.name || `Workspace #${ws.id}`)),
                ws.membershipCount,
                react_1.default.createElement(react_moment_1.default, { format: "lll", className: "font-weight-light", key: 3 }, ws.createdAt),
                react_1.default.createElement(react_moment_1.default, { format: "lll", className: "font-weight-light", key: 4 }, ws.updatedAt),
                react_1.default.createElement(CheckIcon_1.CheckIcon, { checked: ws.archived, key: 5 }),
                ws.enabledIntegrationClasses
                    ? ws.enabledIntegrationClasses.map(type => {
                        return (react_1.default.createElement(reusables_1.IntegrationLogo, { key: type, height: 20, width: 20, integrationType: type, className: "mr-1" }));
                    })
                    : '?',
            ];
        }, filters: react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ResourceList_1.ResourceList.Filter, { name: "searchQuery", defaultValue: "", placeholder: "Name" }),
            react_1.default.createElement(ResourceList_1.ResourceList.Filter, { name: "archived", defaultValue: "showActive", options: [
                    {
                        label: 'Show active workspaces',
                        value: 'showActive',
                    },
                    {
                        label: 'Hide active workspaces',
                        value: 'hideActive',
                    },
                    {
                        label: 'Show active and inactive workspaces',
                        value: 'all',
                    },
                ] }),
            react_1.default.createElement(ResourceList_1.ResourceList.Filter, { name: "deleted", defaultValue: "hideDeleted", options: [
                    {
                        label: 'Hide deleted users',
                        value: 'hideDeleted',
                    },
                    {
                        label: 'Show deleted users',
                        value: 'showDeleted',
                    },
                    {
                        label: 'Show deleted and non-deleted users',
                        value: 'all',
                    },
                ] }),
            react_1.default.createElement(reactstrap_1.Button, { color: "success", size: "sm", className: "ml-2", onClick: () => {
                    toggleAddWorkspaceModal();
                } }, "New workspace"),
            react_1.default.createElement(AddWorkspaceModal, { isOpen: showAddWorkspaceModal, onClose: () => {
                    toggleAddWorkspaceModal(false);
                } })), headers: [
            {
                direction: 'ASC',
                label: 'Name',
                name: 'name',
                width: 30,
            },
            // {
            //   direction: 'ASC',
            //   label: 'Created',
            //   name: 'createdAt',
            //   width: 20,
            // },
            {
                direction: 'ASC',
                label: 'Created',
                name: 'createdAt',
                width: 20,
            },
            {
                direction: 'ASC',
                label: 'Updated',
                name: 'updatedAt',
                width: 20,
            },
            {
                direction: 'ASC',
                label: 'Archived',
                name: 'archived',
                width: 15,
            },
            {
                direction: 'ASC',
                label: 'Integrations',
                name: 'enabledIntegrationClasses',
                width: 25,
            },
        ], query: graphql_1.workspacesWithUserCounts, keys: {
            count: 'workspacesCount',
            item: 'workspaces',
        }, singular: "workspace", plural: "workspaces" }));
};
exports.default = exports.WorkspacesList;
//# sourceMappingURL=WorkspacesList.js.map